import { mapState, mapMutations } from "vuex";

export default {
  name: "barra",
  data() {
    return {
      notificaciones: [{}, {}],
      lnot: 0,
      fecha_alta: ""
    };
  },

  created: function() {
    this.refresh_ss();

    setInterval(() => {
      this.refresh_ss();
    }, 240000);
  },
  computed: {
    ...mapState(["user_data"])
  },
  methods: {
    href_noti(a) {
      if (a == null) {
        return "#";
      } else {
        return a;
      }
    },
    ...mapMutations(["set_user_name"]),

 

    refresh_ss() {
      this.$http
        .post(
          "SERVER/scd/dashboard/",
          {
            a: "br1"
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.data.status == 1) { 
            this.fecha_alta = response.data.date;
            this.notificaciones = response.data.notif;
            this.lnot = response.data.lnot;

            this.set_user_name({
              nombre: response.data.name,
              pic: response.data.pic,
              tipo: response.data.tipo,
              menu_general: response.data.menu_general
            });
          } else {
            window.location.href = "/";
          }
        });
    },

    del_not(id) {
      this.$http
        .post(
          "SERVER/scd/dashboard/",
          {
            a: "deln",
            id: id
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          this.refresh_ss();
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/general/barra/barra.js